module.exports = __webpack_public_path__ + "img/question.49052e35.svg";